import { prop } from 'ramda'

export const language = prop('language')
export const platform = prop('platform')
export const locale = prop('locale')
export const version = prop('version')
export const mode = prop('mode')
